export default "__VITE_ASSET__DCUSDw_F__"